import createActivitiesFromEntities from './createActivitiesFromEntities';
import populateActivities from './populateActivities';
import populateEntities from './populateEntities';
import foundEntities from './foundEntities';
import foundActivities from './foundActivities';
import Activity from '../../schema/Activity';
import TxpObject from '../../schema/TxpObject';

/**
 * @serverTxpBlob - the string of txp blob we get from the server
 * The function returns an object with parsed data - entities and activities.
 * The object is a valid prop for the TXP control.
 */
export default function convertTxpBlobToObject(
    serverTxpBlob: string,
    isInvoiceEnabled?: boolean,
    isServiceReservationEnabled?: boolean,
    shouldCreateActivities?: boolean,
    useEntityId?: boolean
): TxpObject {
    // parse the data into Json
    if (serverTxpBlob) {
        let parsedEntities;
        let parsedBlob: JSON;

        try {
            parsedBlob = JSON.parse(serverTxpBlob);
        } catch (e) {
            parsedBlob = null;
        }

        if (parsedBlob) {
            // parse entities
            let blobEntities = foundEntities(parsedBlob);
            parsedEntities = populateEntities(
                blobEntities,
                isInvoiceEnabled,
                isServiceReservationEnabled,
                useEntityId
            );

            if (parsedEntities) {
                let parsedActivities: Activity[];

                if (shouldCreateActivities) {
                    // create activities
                    parsedActivities = createActivitiesFromEntities(parsedEntities.entitiesArray);
                } else {
                    // parse activities
                    let blobActivities = foundActivities(parsedBlob);
                    parsedActivities = populateActivities(
                        blobActivities,
                        parsedEntities.entitiesDictionary
                    );
                }

                if (parsedActivities && parsedActivities.length > 0) {
                    return {
                        txpEntities: parsedEntities.entitiesDictionary,
                        txpActivities: parsedActivities,
                    };
                }
            }
        }
    }

    return null;
}
